import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import logDeviceIcon from "../../oversight-core/assets/images/site-log-device.svg";
import { IGroWattInverterView } from "../../oversight-core/interfaces/gro-watt-inverter-view";
import VrmInverterInformation from "../../oversight-core/ui-elements/inverter-information/vrm-inverter-information";
import MaterialIcon from "../../oversight-core/ui-elements/material-icon/material-icon";
import { getRelativeTimeFromTimestamp } from "../../oversight-core/utils/time-utils";
import styles from "./gro-watt-device-log-item.module.scss";

interface IProps {
  inverter: IGroWattInverterView;
}

const GroWattDeviceLogItem = (props: IProps) => {
  const { inverter } = props;

  const [collapsed, setCollapsed] = useState(false);

  return (
    <div
      className={`${styles.deviceLogItemContainer} bg-white p-3 rounded-3 cursor-pointer`}
      onClick={() => setCollapsed((ps) => !ps)}
    >
      <Row className="align-items-center justify-content-between">
        <Col className="col-5 col-sm-7">
          <Row className="align-items-center">
            <Col className="col-auto pe-0">
              <img src={logDeviceIcon} alt="Device Icon" />
            </Col>
            <Col className="text-dark font-weight-500 font-size-14">
              {inverter.type}
            </Col>
          </Row>
        </Col>
        <Col className="col-4 text-light font-weight-400 font-size-12">
          Last seen&nbsp;
          {getRelativeTimeFromTimestamp(inverter.lastUpdateTime)}
        </Col>
        <Col className="col-auto">
          <MaterialIcon
            icon={collapsed ? "keyboard_arrow_down" : "keyboard_arrow_right"}
            color="#AEBBD0"
            size={25}
          />
        </Col>
      </Row>
      {collapsed && (
        <div className="ms-4 ps-3 mt-4">
          <VrmInverterInformation
            inverterInfo={[
              {
                title: "Serial Number",
                value: inverter.deviceSn,
              },
              {
                title: "Model",
                value: inverter.model || "-",
              },
              {
                title: "Lost",
                value: inverter.lost,
              },
              {
                title: "Status",
                value: inverter.status,
              },
              {
                title: "Manufacturer",
                value: inverter.manufacturer,
              },
              {
                title: "Device -ID",
                value: inverter.deviceId || "-",
              },
              {
                title: "Data logger Sn",
                value: inverter.dataloggerSn,
              },
            ]}
          />
        </div>
      )}
    </div>
  );
};

export default GroWattDeviceLogItem;
